import { render, staticRenderFns } from "./SampleDamage.vue?vue&type=template&id=3e236a5d"
import script from "./SampleDamage.vue?vue&type=script&lang=js"
export * from "./SampleDamage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports